module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "master-supplier-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master_consumable_item_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Consumable Item List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Master Consumable Item New')))])])]), _c('h1', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("消耗品マスタ新規登録")]), (_vm.isShow) ? _c('div', {
    staticClass: "row"
  }, [_c('master-comsumable-item-input', {
    attrs: {
      "consumable-item-parent": _vm.consumableItem,
      "categories-parent": _vm.categories,
      "suppliers-parent": _vm.suppliers
    },
    on: {
      "sendData": _vm.createConsumableItem
    }
  }), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel panel-default text-center"
  }, [(_vm.displayImageUrl) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('img', {
    staticClass: "img-responsive img-rounded pull-right",
    attrs: {
      "src": _vm.displayImageUrl
    }
  })]) : _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "padding": "80px"
    }
  }, [_c('p', [_vm._v("商品画像を選択")])])])]), _c('div', {
    staticClass: "row text-right margin-top"
  }, [_c('label', [_c('span', {
    staticClass: "btn btn-default"
  }, [_vm._v("画像を選択"), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _c('label', {
    staticClass: "margin-left"
  }, [(_vm.displayImageUrl) ? _c('span', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteFile
    }
  }, [_vm._v("画像を削除")]) : _vm._e()])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2738f9fc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/master-consumable-item-new.pug
// module id = 781
// module chunks = 1